export function getWindow(key) {
  const data = this.getCanvasScope()
  if (!key) {
    return data || {}
  }
  return data?.[key]
}

export function getWindowElements(key) {
  const DynamicIsland = this.getDynamicIsland()
  const DocsView = this.getDocsView()
  const map = {
    explorer: [
      // Canvas.parent.DsNavbar,
      // CanvasNavbar.CanvasPanel,
      DynamicIsland
    ],
    // editorPanels: EditorPanels,
    docs: DocsView,
    modal: this.getCanvasModal()
    // library: DynamicIsland?.Library //[, CanvasNavbar.SearchNavbar],
    // designSystem: [Canvas.DesignSystemPanel, Canvas.DsNavbar],
    // componentEditor: EditorPanels //.ComponentEditor
    // fiddle: Canvas.FiddleView
  }
  return key ? map[key.split('Minimized')[0]] : map
}

export function getWindowKeys(excl = []) {
  const keys = Object.keys(this.getWindowElements())
  return excl ? this.call('filterArrays', keys, excl) : keys
}

export async function setWindow(
  key,
  val,
  opts = { preventUpdate: ['Iframe'] }
) {
  const data = this.getCanvasScope()
  const elementsToUpdate = this.getWindowElements(key)

  const applyElementUpdate = async (elem) => {
    if (elem.props['.isWindowActive']) {
      elem.setNodeStyles(
        val ? elem.props['.isWindowActive'] : elem.props['!isWindowActive']
      )
    } else {
      await elem.update({}, opts)
    }
  }

  data[key] = val
  if (this.call('isArray', elementsToUpdate)) {
    elementsToUpdate.forEach((item) => {
      if (!item.update) {
        return console.error('no update for', item)
      }

      const t = setTimeout(async () => {
        await applyElementUpdate(item)
        clearTimeout(t)
      }, 15)
    })
  } else if (!elementsToUpdate?.update) {
    this.warn('No update for', key, elementsToUpdate)
  } else if (!opts.forceUpdate && this.call('isBoolean', val)) {
    elementsToUpdate.setNodeStyles({ display: val ? 'flex' : 'none' })
  } else {
    await applyElementUpdate(elementsToUpdate)
  }

  this.call('setCookie', key, val)
  this.syncCanvas({ [key]: val })
}

export function openWindow(key, opts) {
  return this.setWindow(key, true, { forceUpdate: true, ...opts })
}

export function closeWindow(key, opts) {
  return this.setWindow(key, false, { forceUpdate: true, ...opts })
}

export function refreshWindow(key, opts) {
  const data = this.getCanvasScope()
  this.setWindow(key, data[key], { forceUpdate: true, ...opts })
}

export function toggleWindow(key, opts) {
  const data = this.getCanvasScope()
  this.setWindow(key, !data[key], { forceUpdate: true, ...opts })
}

export function isWindowMinimized(key) {
  const data = this.getCanvasScope()
  return data[`${key}Minimized`]
}

export function isWindowExpanded(key) {
  return !this.isWindowMinimized(key)
}

export function minimizeWindow(key) {
  const data = this.getCanvasScope()
  data[`${key}Minimized`] = true
  return this.refreshWindow(key)
}

export function toggleExpandWindow(key) {
  const data = this.getCanvasScope()
  data[`${key}Minimized`] = !data[`${key}Minimized`]
  return this.refreshWindow(key)
}

export function expandWindow(key) {
  const data = this.getCanvasScope()
  data[`${key}Minimized`] = false
  return this.refreshWindow(key)
}

export function toggleLibrary() {
  this.toggleWindow('library')
  this.getDynamicIsland().setNodeStyles(
    this.getDynamicIsland().props[
      this.getWindow('library') ? '.isLibraryActive' : '!isLibraryActive'
    ]
  )
  this.getDynamicIsland().Library.setNodeStyles(
    this.getDynamicIsland().Library.props[
      this.getWindow('library') ? '.isVisible' : '!isVisible'
    ]
  )
  this.getDynamicIsland().CanvasProjectSidebar.setNodeStyles(
    this.getDynamicIsland().CanvasProjectSidebar.props[
      this.getWindow('library') ? '!isVisible' : '.isVisible'
    ]
  )
}
